import { Box, Stack, Typography } from '@mui/material';
import { ReactNode } from 'react';

import { getPublicImageUrl } from '@/utils/staticFiles';

export interface AnnouncementSlideContentProps {
  imageUrl: string;
  imageAlt: string;
  bodyText: ReactNode;
}

export function AnnouncementSlideContent({
  imageUrl,
  imageAlt,
  bodyText,
}: AnnouncementSlideContentProps) {
  return (
    <Stack spacing={3} pb={4} alignItems="center" maxWidth="550px">
      <Box
        sx={{
          width: '100%',
          overflow: 'hidden',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <img
          src={getPublicImageUrl(imageUrl)}
          alt={imageAlt}
          style={{
            maxWidth: '100%',
            height: 'auto',
            display: 'block',
            maxHeight: '300px',
          }}
        />
      </Box>
      <Typography sx={{ textAlign: 'center' }} variant="body-s">
        {bodyText}
      </Typography>
    </Stack>
  );
}
